import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import { Grid, Typography } from '@material-ui/core';
import { DataGrid, Modals, Button, DataAction, Utils } from 'ecrion-components';
import React from 'react';

var BouncedEmails = function BouncedEmails() {
  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      forceRefresh = _React$useState2[0],
      setForceRefresh = _React$useState2[1];

  return React.createElement(React.Fragment, null, React.createElement(Grid, {
    container: true,
    justify: "space-between",
    alignItems: "flex-start"
  }, React.createElement(Grid, {
    item: true,
    xs: 9
  }, React.createElement(Typography, {
    variant: "h6"
  }, "Bounced Emails")), React.createElement(Grid, {
    container: true,
    item: true,
    xs: 3,
    justify: "flex-end",
    alignItems: "flex-end"
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    onClick: function onClick() {
      Modals.open({
        type: Modals.TYPES.CONFIRMATION,
        props: {
          title: 'Remove all emails from bounce list',
          message: 'Are you sure you want to remove all emails from bounces list?',
          confirmLabel: 'Remove All',
          confirmingLabel: 'Removing...',
          confirmColor: 'danger',
          onConfirm: function onConfirm() {
            return Utils.request({
              url: '/backend/emailbouncelist',
              method: 'DELETE'
            }).then(function () {
              setForceRefresh(forceRefresh + 1);
            });
          }
        }
      });
    },
    color: "danger",
    style: {
      right: '8px'
    }
  }, "Remove All")), React.createElement(Grid, {
    item: true
  }, React.createElement(Button, {
    onClick: function onClick() {
      var emailBouncedBaseUrl = "".concat(Utils.getHost(), "backend/emailbouncelist/getemailsbouncedascsv");
      var token = localStorage.getItem('ECR.EOS.AccessToken');
      var emailBoouncedContentUrl = "".concat(emailBouncedBaseUrl, "?accessToken=") + token;
      window.open(emailBoouncedContentUrl, '_self');
    }
  }, "Export To CSV"))), React.createElement(Grid, {
    item: true,
    xs: 12
  }, React.createElement(DataGrid, {
    id: "bounced-emails",
    key: forceRefresh,
    dataType: "bouncedEmail",
    viewProps: {
      hideModeSwitcher: true
    },
    styles: {
      elevation: 0,
      hideBorder: true
    },
    contextMenu: [{
      type: 'delete',
      onClick: function onClick(e, item) {
        DataAction.item({
          dataType: 'bouncedEmail',
          id: item.Email
        }).delete({
          useConfirmation: true
        });
      }
    }]
  }))));
};

export default BouncedEmails;